var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn--primary ml-3 mb-3",attrs:{"type":"button"},on:{"click":_vm.popChangeKeyModal}},[_vm._v(" "+_vm._s(_vm.btnName || "Change key")+" ")]),_c('ChangeKeyModal',{attrs:{"id":_vm.keyType,"closeModal":_vm.closeModal,"keyType":_vm.keyType,"title":_vm.modalTitle,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }